import React from "react";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CssBaseline } from "@mui/material";
import AOS from "aos";
import "react-toastify/dist/ReactToastify.css";

import "./index.css";
import "aos/dist/aos.css";

import App from "./App";
import "./config/i18n";

import { ThemeProviderWrapper } from "./contexts/ThemeContext";
import { UserProvider } from "./contexts/UserContext";
import { VisitorIdProvider } from "./contexts/VisitorContext";
import { AnalyticsProvider } from "./contexts/AnalyticsContext";

AOS.init();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ThemeProviderWrapper>
    <CssBaseline />

    <VisitorIdProvider>
      <UserProvider>
        <AnalyticsProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ToastContainer position="bottom-right" />

            <App />
          </LocalizationProvider>
        </AnalyticsProvider>
      </UserProvider>
    </VisitorIdProvider>
  </ThemeProviderWrapper>
);
